import api from "./core";

const basePath = "api/portal/Patients";

export default {
  async getImaginePaymentRequest(patientId) {
    const result = await api.get(`${basePath}/ImaginePaymentRequest/${patientId}`);
    return result.data;
  },
  updateLastRequestIdFetchTime(id, disable, extraHeaders = {}){
    return api.post(`${basePath}/UpdateLastRequestIdFetchTime/${id}?disable=${ disable }`,{}, extraHeaders);
  },
  processPatientPayment(id, extraHeaders = {}){
    return api.post(`${basePath}/ProcessPatientPayment/${id}`,{}, extraHeaders);
  },
  patientBalanceDetails(id) {
    return api.post(`${basePath}/patientBalanceDetails/${id}`, {}, {});
  },
  getPaymentHistory(id){
    return api.get(`${basePath}/getPaymentHistory/${id}`);
  },
  getCreditCards(patientId) {
    return api.get(`${basePath}/getCreditCards/${patientId}`);
  },
  removeCreditCard(token, patientId = null) {
    const queryParams = patientId ? `?patientId=${patientId}` : '';
    return api.delete(`${basePath}/deleteCreditCard/${token}${queryParams}`);
  },
  getPaymentRequestId(patientId) {
    return api.get(`${basePath}/getPaymentRequestId/${patientId}`);
  },
  getCreditCardByAccountNumber(accountNumber) {
    return api.get(`${basePath}/getSaveCardByAccountNumber/${accountNumber}`);
  },
  syncPatientDemographicsWithPeregrine(data) {
    return api.post(`${basePath}/syncPatientDemographicsWithPeregrine`, data);
  },
  get(patientId) {
    return api.get(`${basePath}/${patientId}`);
  },
  getPatientByImaginePeregrineRefNumber(accountNumber, lastName, locationId = null) {
    const queryParams = new URLSearchParams({
      accountNumber,
      lastName
    });
    if (locationId) {
      queryParams.append('locationId', locationId);
    }
    return api.get(`${basePath}/getCreditCardsByAccountNumber?${queryParams.toString()}`);
  }
};
